import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Compressor from 'compressorjs';
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';
import { useSelector } from "react-redux";

import PageChange from "../../../../component/pageChange";
import LogOut from "../../../../component/dashboard/user/logout/logout";
import toast from "react-hot-toast";
import ThreeDScene from "../../../../component/3dEditor/ThreeDScene";


export default function Marker({
    id,
    name,
    type
}) {
    const { login, token } = useSelector((item) => item.user)
    const [pictureMarker, setPictureMarker] = useState(null)
    const [markerDataError, setMarkerDataError] = useState(null)
    const [contentData, setContentData] = useState(null)
    const [contentDataType, setContentDataType] = useState(null) // VIDEO, OBJ
    const [contentDataError, setContentDataError] = useState(null)
    const [voiceMarker, setVoiceMarker] = useState(null)
    const [voiceMarkerDataError, setVoiceMarkerDataError] = useState(null)

    const [stepPage, setStepPage] = useState(1)

    var durationConvert = 0;
    const [progressBar, setProgressBar] = useState(0);
    const [progressDone, setProgressDone] = useState([]) // MARKER, VIDEO

    // Edit
    const [isDataLoad, setIsDataLoad] = useState(false)
    const [data, setData] = useState(null)

    // 3D Object step page 2
    const [scaleObject, setScaleObject] = useState(1.0)
    const [positionObject, setPositionObject] = useState({ x: 0, y: 0, z: 0 })
    const [rotateObject, setRotateObject] = useState({ x: 0, y: 0, z: 0 })


    useEffect(() => {
        getAugmentedReality(id)
    }, [])

    const axiosInstance = axios.create({
        baseURL: `${process.env.REACT_APP_SERVER}`,
        timeout: 3000000 // only wait
    });

    async function getAugmentedReality(id) {
        await fetch(`${process.env.REACT_APP_SERVER}/api/nft/${id}`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        setData(result.data)
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }

    const handleButtonDisableContinue = () => {
        if (pictureMarker != null && contentData != null) {
            return false
        }
        return true
    }

    const checkSetMarkerData = (e) => {
        if (e.target.files[0].size > 5000001) {
            setMarkerDataError("حجم فایل شما بیش از حد مجاز می باشد")
            return false;
        }
        const name = e.target.files[0].name
        const array = name.split(".");
        const format = array[array.length - 1];
        if (format.toLowerCase() != "png" && format.toLowerCase() != "jpeg" && format.toLowerCase() != "jpg") {
            setMarkerDataError("فرمت صحیح نمی باشد")
            return false;
        } else {
            setMarkerDataError(null)
            setPictureMarker(e.target.files[0])
            return true;
        }
    }

    const checkSetContentData = (e) => {
        if (e.target.files[0].size > 50000001) {
            setContentDataError("حجم فایل شما بیش از حد مجاز می باشد")
            return;
        }
        const name = e.target.files[0].name
        const array = name.split(".");
        const format = array[array.length - 1];
        if (format.toLowerCase() != "mp4" && format.toLowerCase() != "mov" && format.toLowerCase() != "glb") {
            setContentDataError("فرمت صحیح نمی باشد")
        } else {
            if (format.toLowerCase() == "mp4" || format.toLowerCase() == "mov") {
                setContentDataType("VIDEO")
            }
            if (format.toLowerCase() == "glb") {
                setContentDataType("OBJ")
            }
            setContentDataError(null)
            setContentData(e.target.files[0])
        }
    }

    const checkSetVoiceMarkerData = (e) => {
        if (!e.target.files || !e.target.files[0]) {
            setContentDataError("فایلی انتخاب نشده است");
            return;
        }

        const file = e.target.files[0];
        const maxSize = 10 * 1024 * 1024 + 1; // 10MB + 1 byte

        if (file.size > maxSize) {
            setContentDataError("حجم فایل شما بیش از حد مجاز می‌باشد");
            return;
        }

        const allowedFormats = ["mp3", "aac", "wav", "ogg", "webm"];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedFormats.includes(fileExtension)) {
            setContentDataError("فرمت فایل انتخاب‌ شده معتبر نمی‌باشد. فرمت‌های مجاز: MP3, AAC, WAV, OGG, WEBM");
            return;
        }
        setContentDataError(null); // پاک کردن خطاها
        setVoiceMarker(file); // ذخیره فایل
        return true;
    };


    const ffmpeg = createFFmpeg({
        progress: (e) => {
            if (e.duration) {
                durationConvert = e.duration
            }
            if (e.time) {
                var fin = Math.round(((e.time + durationConvert) / durationConvert * 100) - 100)
                setProgressBar(fin)
                setTimeout(() => {
                    document.getElementById("progressBar").style.width = fin.toString() + "%";
                }, 100);
            }
        },
        log: true,
    });

    const compiler = new window.MINDAR.IMAGE.Compiler();
    const loadImage = useCallback(async (file) => {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = URL.createObjectURL(file);
        })
    }, []);

    function blobToFile(theBlob, fileName) {
        return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
    }

    async function getFileFromUrl(url, name, defaultType = 'image/jpeg') {
        const response = await fetch(url);
        const data = await response.blob();
        return new File([data], name, {
            type: data.type || defaultType,
        });
    }

    const startMakeAR = async (e) => {
        e.preventDefault();
        if (contentDataType == "VIDEO") {
            setProgressDone([{
                title: "احراز هویت",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "آنالیز داده ها",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "ایجاد نشانگر",
                status: "WAIT" // DONE, WAIT
            },
            {
                title: "تبدیل ویدیو",
                status: "WAIT" // DONE, WAIT
            },
            {
                title: "ارسال داده ها به سرور",
                status: "WAIT" // DONE, WAIT
            }])
        } else {
            setProgressDone([{
                title: "احراز هویت",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "آنالیز داده ها",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "ایجاد نشانگر",
                status: "WAIT" // DONE, WAIT
            },
            {
                title: "ارسال داده ها به سرور",
                status: "WAIT" // DONE, WAIT
            }])
        }

        setStepPage(3)
        const images = [];

        const promises = await data.image.map(async img => {
            const numImg = new Promise(async (resolve, reject) => {
                const imageURL = `${process.env.REACT_APP_SERVER}/uploads/${data.user.username}/image/${img}`
                const file = await getFileFromUrl(imageURL, img);
                const loaded = await loadImage(file)
                resolve(loaded)
            });
            return numImg
        })

        const imageFiles = await Promise.all(promises)
        images.push(...imageFiles)
        images.push(await loadImage(pictureMarker));
        await compiler.compileImageTargets(images, (progress) => {
            setProgressBar(Math.round(progress))
            document.getElementById("progressBar").style.width = Math.round(progress).toString() + "%";
        });
        setTimeout(async () => {
            const exportedBuffer = await compiler.exportData();
            var blob = new Blob([exportedBuffer]);
            editStatusProcess("ایجاد نشانگر", "DONE")
            submitForm(blobToFile(blob, "targets.minogar"))
        }, 2000);
    }

    async function convertUserVideo(video) {
        await ffmpeg.load();
        ffmpeg.FS('writeFile', video.name, await fetchFile(video));
        await ffmpeg.run('-i', video.name, '-c:v', 'libx264', '-vf', 'scale=720:-2,format=yuv420p', '-c:a', 'copy', '-movflags', '+faststart', 'output.mp4');
        const data = ffmpeg.FS('readFile', 'output.mp4');
        const blob = new Blob([data.buffer], { type: 'video/mp4' })
        var file = blobToFile(blob, "final.mp4");
        return file;
    }

    const submitForm = async (blobMind) => {

        setProgressBar(0)
        const formData = new FormData();

        formData.append("id", id);
        formData.append("image", new File([pictureMarker], pictureMarker.name, { lastModified: new Date().getTime(), type: pictureMarker.type }));
        if (contentDataType == "VIDEO") {
            const videoConverted = await convertUserVideo(contentData).catch(error => {
                console.error("Convert error:", error)
                return contentData;
            });
            formData.append("video", videoConverted);
            editStatusProcess("تبدیل ویدیو", "DONE")
        } else {
            formData.append("glb", contentData);
            formData.append("size_model", JSON.stringify({
                scale: scaleObject,
                position: {
                    x: positionObject.x,
                    y: positionObject.y,
                    z: positionObject.z
                },
                rotation: {
                    x: rotateObject.x,
                    y: rotateObject.y,
                    z: rotateObject.z
                }
            }));
        }
        if (voiceMarker) {
            formData.append("voice", voiceMarker);
        }
        formData.append("mind", blobMind);
        formData.append("types", type);

        await axiosInstance.post("/api/nft/add", formData, {
            headers: {
                Authorization: "ArNew " + token,
            },
            onUploadProgress: data => {
                var percentComplete = Math.ceil((100 * data.loaded) / data.total);
                setProgressBar(percentComplete)
                document.getElementById("progressBar").style.width = percentComplete.toString() + "%";
            }
        })
            .then(
                function (response) {
                    if (response.data.status === "success") {
                        editStatusProcess("ارسال داده ها به سرور", "DONE")
                        if (typeof window !== 'undefined') {
                            window.location.href = `${process.env.REACT_APP_CLIENT}/projects/edit/${response.data.data._id}`;
                        }
                    } else {
                        toast.error(response?.data?.msg);
                    }
                }
            ).catch(function ({ response }) {
                if (response.status !== 200) {
                    toast.error(response?.data?.msg)
                }
            });
    }

    const editStatusProcess = (title, status) => {
        setProgressDone(prevState => {
            return prevState.map((item) => {
                return item.title === title ? { title: title, status: status } : item
            })
        })
    }


    return (
        isDataLoad ? (
            <>

                {stepPage === 1 && (
                    <>
                        <h1 className="font-extrabold text-2xl text-start text-gray-700 mt-5">شما درحال ایجاد واقعیت افزوده براساس نشانگر با نام <span className="text-gray-900">«{name}»</span> هستید</h1>
                        <h4 className="font-normal text-lg text-start text-gray-600 mt-3">
                            میخوایی حرفه ای عمل کنی؟ به چندتا نکته توجه کن!
                            <p className="mt-3 mx-2 text-base">1- از عکس های شلوغ برای نشانگر استفاده کن تا عملکرد بهتری داشته باشی.</p>
                            <p className="mt-2 mx-2 text-base">2- دقت کنید تصاویری که به عنوان نشانگر استفاده میکنید زیر ۵ مگابایت باشند.</p>
                            <p className="mt-2 mx-2 text-base">3- از ویدیو های زیر ۵۰ مگابایت استفاده کن، پلتفرم به صورت خودکار ویدیو های شما رو کم حجم و بهینه میکنه.</p>
                        </h4>

                        <h1 className="col-span-2 font-extrabold text-xl text-start text-black my-auto mt-8 mx-5">بارگذاری تصویر نشانگر</h1>
                        <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                            تصویری که اسکن می شود و واقعیت افزوده را فعال می کند
                        </h4>
                        <div className="flex items-center justify-center w-full">
                            <label htmlFor="dropzone-file-target" className={`relative flex flex-col items-center justify-center w-full h-64 border-2 ${markerDataError ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                                {pictureMarker != null ?
                                    (
                                        <>
                                            <img className="free-image p-3" src={URL.createObjectURL(pictureMarker)} />
                                            <div
                                                onClick={() => { setPictureMarker(null) }}
                                                className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z" /></svg>
                                            </div>
                                        </>
                                    )
                                    :
                                    (
                                        <>

                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                </svg>
                                                <p className="text-red-500 text-sm mb-2">{markerDataError}</p>
                                                <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                                <p className="text-xs text-gray-500 dark:text-gray-400">PNG, JPG (MAX. 5 MB)</p>
                                            </div>
                                            <input
                                                id="dropzone-file-target"
                                                type="file"
                                                className="hidden"
                                                multiple={false}
                                                accept="image/png, image/jpeg"
                                                onChange={async (e) => {
                                                    if (e.target.files.length > 0) {
                                                        if (checkSetMarkerData(e)) {
                                                            new Compressor(e.target.files[0], {
                                                                quality: 0.6,
                                                                maxWidth: 900,
                                                                maxHeight: 900,
                                                                success: (compressedResult) => {
                                                                    setPictureMarker(compressedResult)
                                                                },
                                                            });
                                                        }
                                                    }
                                                }}
                                            />
                                        </>
                                    )
                                }
                            </label>
                        </div>
                        <h1 className="font-extrabold text-xl text-start text-black mt-8 mx-5">بارگذاری محتوا</h1>
                        <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                            محتوای شما میتواند شامل یک ویدیو یا مدل سه بعدی باشد
                        </h4>
                        <div className="flex items-center justify-center w-full">

                            <label htmlFor="dropzone-file-content" className={`relative flex flex-col items-center justify-center w-full h-64 border-2 ${contentDataError ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                                {contentData != null ?
                                    (
                                        <>
                                            {contentDataType == "VIDEO" ?
                                                (
                                                    <>
                                                        <video className="free-image p-3" autoPlay={false} controls={true} src={URL.createObjectURL(contentData)} />

                                                    </>
                                                )
                                                :
                                                (
                                                    <>
                                                        <model-viewer loading="eager" auto-rotate alt="Uploaded Model" src={URL.createObjectURL(contentData)} shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>
                                                    </>
                                                )
                                            }
                                            <div
                                                onClick={() => { setContentData(null); setContentDataType(null) }}
                                                className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z" /></svg>
                                            </div>

                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                </svg>
                                                <p className="text-red-500 text-sm mb-2">{contentDataError}</p>
                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                                <p className="text-xs text-gray-500">MP4, MOV, GLB (MAX. 50 MB)</p>
                                            </div>
                                            <input
                                                id="dropzone-file-content"
                                                type="file"
                                                className="hidden"
                                                multiple={false}
                                                onChange={(e) => {
                                                    if (e.target.files.length > 0) {
                                                        checkSetContentData(e)
                                                    }
                                                }}
                                            />
                                        </>
                                    )
                                }

                            </label>
                        </div>

                        <h1 className="col-span-2 font-extrabold text-xl text-start text-black my-auto mt-8 mx-5">بارگذاری صدا (اختیاری)</h1>
                        <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                            صدای انتخابی بعد از اجرای واقعیت افزوده پخش خواهد شد. (اگر ویدیو بارگذاری کردید که صوت دارد، نیاز به آپلود جداگانه صوت نیست)
                        </h4>
                        <div className="flex items-center justify-center w-full">
                            <label htmlFor="dropzone-file-target-voice" className={`relative flex flex-col items-center justify-center w-full h-64 border-2 ${voiceMarkerDataError ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                                {voiceMarker != null ?
                                    (
                                        <>
                                            <audio controls >
                                                <source src={URL.createObjectURL(voiceMarker)} type="audio/mpeg" />
                                                مرورگر شما از پخش این فایل صوتی پشتیبانی نمی‌کند.
                                            </audio>
                                            <div
                                                onClick={() => { setVoiceMarker(null) }}
                                                className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z" /></svg>
                                            </div>
                                        </>
                                    )
                                    :
                                    (
                                        <>

                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                </svg>
                                                <p className="text-red-500 text-sm mb-2">{voiceMarkerDataError}</p>
                                                <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                                <p className="text-xs text-gray-500 dark:text-gray-400">MP3, AAC, WAV, OGG, WEBM (MAX. 10 MB)</p>
                                            </div>
                                            <input
                                                id="dropzone-file-target-voice"
                                                type="file"
                                                className="hidden"
                                                multiple={false}
                                                accept="audio/mp3, audio/aac, audio/wav, audio/ogg, audio/webm"
                                                onChange={async (e) => {
                                                    if (e.target.files.length > 0) {
                                                        if (checkSetVoiceMarkerData(e)) {
                                                            setVoiceMarker(e.target.files[0])
                                                        }
                                                    }
                                                }}
                                            />
                                        </>
                                    )
                                }
                            </label>
                        </div>

                        <div className="w-full flex justify-end">
                            < button
                                disabled={handleButtonDisableContinue()}
                                className={` ${handleButtonDisableContinue() ? "bg-gray-100 text-gray-700 font-normal" : "bg-emerald-500 hover:shadow-lg text-white active:bg-emerald-600 font-bold"} uppercase text-lg px-6 py-3 my-5 rounded shadow  outline-none focus:outline-none ease-linear transition-all duration-150`}
                                type="button"
                                onClick={(e) => {
                                    contentDataType == "VIDEO" ? startMakeAR(e) : stepPage == 1 ? setStepPage(2) : startMakeAR(e)
                                }}
                            >
                                {contentDataType == "VIDEO" ? "ثبت و ایجاد" : stepPage == 1 ? "ادامه" : "ثبت و ایجاد"}
                            </button >
                        </div>
                    </>
                )}

                {stepPage === 2 &&
                    (
                        <>
                            <div className="h-[700px] mb-4">
                                <ThreeDScene
                                    scaleObject={scaleObject}
                                    setScaleObject={setScaleObject}
                                    positionObject={positionObject}
                                    setPositionObject={setPositionObject}
                                    rotateObject={rotateObject}
                                    setRotateObject={setRotateObject}
                                    marker={pictureMarker}
                                    model={contentData}
                                />
                            </div>
                            <div className="w-full flex justify-end">
                                < button
                                    disabled={handleButtonDisableContinue()}
                                    className={` ${handleButtonDisableContinue() ? "bg-gray-100 text-gray-700 font-normal" : "bg-emerald-500 hover:shadow-lg text-white active:bg-emerald-600 font-bold"} uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none ease-linear transition-all duration-150`}
                                    type="button"
                                    onClick={startMakeAR}
                                >
                                    ثبت و ایجاد
                                </button >
                            </div>
                        </>
                    )}

                {stepPage === 3 &&
                    <>
                        <div className="m-auto w-1/2 lg:w-1/3 xl:w-1/3">
                            <img className="free-image w-full object-cover rounded-lg" src={process.env.REACT_APP_ADDRESS + "/panel/upload-process.gif"} />
                        </div>

                        <div className="mt-8" role="status">
                            <span className="p-2">درحال ایجاد واقعیت افزوده هستیم، این پردازش به حجم داده های شما بستگی دارد.</span>
                            <div className="my-4">
                                <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                    <div id="progressBar" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progressBar}%</div>
                                </div>
                            </div>
                        </div>
                        {progressDone.map((item, index) => {
                            return (
                                <div key={index} className="flex p-2">
                                    {
                                        item.status == "DONE" ?
                                            (
                                                <>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="#00ac8b" height="1.2em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                                    <div className="px-2 font-normal text-base text-black">{item.title}</div>
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="inline text-gray-200 animate-spin fill-blue-600" height="1.2em" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                    </svg>
                                                    <span className="px-2 font-normal text-base text-black">{item.title}</span>
                                                </>
                                            )
                                    }
                                </div>
                            )
                        })}
                    </>}

            </>
        ) : (
            <PageChange />
        )
    );
}